import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Button, Card, CardActions, CardHeader, CardMedia, Grid, LinearProgress, List, ListItem, Theme, Typography, withStyles } from '@material-ui/core';
import { member as v_member, basic, Values, SNACKBAR_TIME } from '../../../request/values';
import axios from 'axios';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { getMember } from '../../../request/request';
import { COLORS } from '../../../shared/Theme';
import DialogConfirm from '../../../components/Dialog';
import ToastStr from '../../../request/toastStr';
import { formatMoney, getTranslatedLicenseName } from '../../../locales/formatModule';

const useStyles = makeStyles((theme: Theme) => ({
	titleIcon: {
		width: '6vw',
	},
	licenseList: {
		paddingTop: '12px',
		//alignContent: 'center',
		width: '100vw',
		height: '88vh',
		overflowY: 'auto',
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		fontSize: '4vw',
		color: `${COLORS.BROWNISH_GREY}`,
		// minWidth: 405,
		[theme.breakpoints.up('md')]: {
			padding: '50px 5vw',
			height: '100vh',
		},
		[theme.breakpoints.up('lg')]: {
			padding: '50px 10vw',
			height: '100vh',
		},
	},
	card: {
		width: '100%',
		height: 'auto',
		border: 'solid 1px #d3d3d3',
		boxShadow: 'none',
		backgroundSize: 'contain',
		paddingTop: '1.2vh',
		paddingBottom: '1.2vh',
	},
	cardHeader: {
		'& span > p': {
			fontSize: '3vw',
			color: `${COLORS.BROWNISH_GREY}`,
			fontFamily: 'NanumR',
			fontWeight: 'bold',
			[theme.breakpoints.up('md')]: {
				fontSize: '2vw',
			},
		},
		'& #cardHelpIcon span img': {
			width: '10vw',
			height: '10vw',
		},
		'& #cardHelpIcon': {
			padding: 0,
		},
		paddingTop: 0,
		paddingLeft: '2.5vw',
		paddingBottom: 0,
		alignItems: 'flex-start',
	},
	media: {
		height: '25.5vh',
		width: '94%',
		margin: 'auto',
		backgroundSize: 'contain',
		[theme.breakpoints.up('md')]: {
			margin: '3vh auto',
		},
	},
	cardAction: {
		height: '2vh',
		padding: '4vw',
		margin: 5,
	},
	overlay: {
		backgroundColor: `${COLORS.PUMPKIN}`,
		zIndex: 100,
		position: 'absolute',
		opacity: 0.9,
		width: '100%',
		height: '100%',
		top: 0,
		justifyContent: 'center',
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		'& img': {},
	},
	nextOverlay: {
		backgroundColor: `${COLORS.WATER_BLUE}`,
	},
	overlayImage: {
		width: '20vw',
		height: 'auto',
		marginBottom: '2vh',
		backgroundSize: 'contain',
		[theme.breakpoints.up('md')]: {
			width: '12vw',
		},
	},

	icon: {
		width: '4.5vw',
		height: '4.5vw',
		maxWidth: '35px',
		maxHeight: '35px',
	},

	button: {
		width: '40vw',
		height: '5vh',
		backgroundColor: `${COLORS.PUMPKIN}`,
		color: `${COLORS.WHITE}`,
		padding: 0,
		...theme.typography.body1,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		[theme.breakpoints.up('md')]: {
			width: '60%',
			height: '70%',
			...theme.typography.body1,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
		},
	},
	title: {
		fontSize: '3.5vw',
	},
	iconHeight: {
		[theme.breakpoints.up('md')]: {
			height: '40px',
		},
	},
	iconItem: {
		[theme.breakpoints.up('md')]: {
			height: '100%',
			display: 'flex',
			alignItem: 'center',
		},
	},
}));

const LicenseList: React.FC<any> = (props) => {
	const { member } = props;
	const { t } = useTranslation('common');
	const classes = useStyles();
	const history = useHistory();

	const [license, setLicense] = useState<iLicenseItem[]>();
	const [now, setNow] = useState<any>();
	const [overlayAttr, setOverlayAttr] = useState<any>();

	const getLicenseList = () => {
		let url = new URL(basic.server + v_member.member + v_member.license_list);
		let params = {
			companyNum: member.companyNum,
			classVersion: member.classVersion,
		};
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data: any) => {
				setNow((prevState: any) => data.now);
				setLicense(data.licenses);

				const firstCantIndex = data.licenses.findIndex((el: any) => el.licenseStatus === 'cant');
				if (firstCantIndex === -1) {
					setOverlayAttr({ lastLicenseNum: -1, canLicenseName: '' });
				} else {
					setOverlayAttr({
						lastLicenseNum: data.licenses[firstCantIndex].licenseNum,
						canLicenseName: data.licenses[firstCantIndex - 1].licenseName,
					});
				}
			});
	};

	const setLicenseStatus = (e: any, index: number, status: string, regDate: string, now: string) => {
		e.preventDefault();
		setNow((prevState: any) => now);
		let l = license;

		if (l != undefined) {
			let g = l[index];
			g.licenseStatus = status;
			g.licenseRegDate = regDate;

			setLicense([...l.slice(0, index), g, ...l.slice(index + 1)]);
		}
	};

	const goLicenseManual = (licenseNum: number) => {
		history.push(`/license/material/${licenseNum}`);
	};

	useEffect(() => {
		getLicenseList();
	}, []);

	return (
		<div className="contentList" data-testid="manu-license-list-dashboard">
			<Box display="flex" justifyContent="center" alignItems="center">
				<List className={classes.licenseList}>
					{license != null &&
						license.map((item: any, index) => {
							return (
								<ListItem
									style={{
										padding: 0,
										paddingBottom: 0,
										marginBottom: '1.7vh',
									}}
								>
									<LicenseItem
										key={item.licenseNum}
										now={now}
										overlayAttr={overlayAttr}
										{...item}
										handleHelpClick={(e: any) => goLicenseManual(item.licenseNum)}
										licenseStatus={item.licenseStatus}
										getLicenseList={getLicenseList}
										setLicenseStatus={(e: any, status: string, regDate: string, now: string) => setLicenseStatus(e, index, status, regDate, now)}
									></LicenseItem>
								</ListItem>
							);
						})}
					{/* {LicenseItemRender} */}
				</List>
			</Box>
		</div>
	);
};

interface iLicenseItem {
	licenseNum: number;
	licenseName: string;
	licenseLevel: number;
	licenseDevelopTime: number;
	productSalePrice: number;
	licenseImage: string;
	licenseMenualFile: string;
	licensePrice: number;
	licenseStatus: string;
	licenseRegDate: string;
	setLicenseStatus: Function;
	getLicenseList: Function;

	overlayAttr: any;
	handleHelpClick: any;
	now: any;
}

const LicenseItem: React.FC<iLicenseItem> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('object');
	const licenseName = getTranslatedLicenseName(t, props.licenseName);
	const { overlayAttr } = props;

	return (
		<Card className={classes.card}>
			{props.licenseStatus === 'cant' &&
				overlayAttr !== undefined &&
				overlayAttr.lastLicenseNum !== -1 &&
				(overlayAttr.lastLicenseNum === props.licenseNum ? (
					<OverlayLock firstCant={true} licenseName={overlayAttr.canLicenseName} />
				) : (
					<OverlayLock firstCant={false} licenseName={overlayAttr.canLicenseName} />
				))}
			<CardHeader
				className={classes.cardHeader}
				title={
					<>
						<Typography>{`Lv. ${props.licenseLevel} ${licenseName}`}</Typography>
					</>
				}
			/>
			<CardMedia className={classes.media} image={basic.server + '/displayImage?fileName=' + props.licenseImage} />
			<CardActions className={classes.cardAction}>
				{props.licenseStatus == 'complete' ? (
					<LicenseItemComplete
						licenseName={props.licenseName}
						licenseDevelopTime={props.licenseDevelopTime}
						licenseRegDate={props.licenseRegDate}
						getLicenseList={props.getLicenseList}
						now={props.now}
					/>
				) : (
					<LicenseItemCan
						licensePrice={props.licensePrice}
						licenseDevelopTime={props.licenseDevelopTime}
						licenseNum={props.licenseNum}
						productSalePrice={props.productSalePrice}
						licenseImage={props.licenseImage}
						licenseLevel={props.licenseLevel}
						licenseName={props.licenseName}
						licenseStatus={props.licenseStatus}
						setLicenseStatus={props.setLicenseStatus}
					/>
				)}
			</CardActions>
		</Card>
	);
};

interface iLicenseItemCan {
	licensePrice: number;
	licenseDevelopTime: number;
	licenseNum: number;
	productSalePrice: number;
	licenseImage: string;
	licenseLevel: number;
	licenseName: string;
	licenseStatus: string;
	setLicenseStatus: Function;
}

const LicenseItemCan: React.FC<iLicenseItemCan> = (props) => {
	const { t } = useTranslation('student');
	const [dialogState, setDialogState] = useState(false);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const { t: tObject } = useTranslation('object');
	const licenseName = getTranslatedLicenseName(tObject, props.licenseName);

	const classes = useStyles();

	const handleClose = () => {
		setDialogState(false);
	};

	const handleOpen = () => {
		if (!dialogState) {
			setDialogState(true);
		}
	};

	const getLicenseRnd = (e: any) => {
		const member = getMember();

		let url = new URL(basic.server + v_member.member + v_member.license_rnd);
		axios({
			method: 'POST',
			withCredentials: true,
			url: url.toString(),
			data: {
				companyNum: member.companyNum,
				classCode: member.classCode,
				licenseNum: props.licenseNum,
				licensePrice: props.licensePrice,
				licenseLevel: props.licenseLevel,
				licenseImage: props.licenseImage,
				productSalePrice: props.productSalePrice,
				licenseName: props.licenseName,
			},
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code == Values.SUCCESS_CODE) {
					enqueueSnackbar(ToastStr.LICENSE_RND_REQUEST_SUCCESS_STR, {
						variant: 'success',
						autoHideDuration: SNACKBAR_TIME,
					});
					props.setLicenseStatus(e, 'complete', data.regDate, data.now);
				} else if (data.code == Values.FAIL_CODE) {
					enqueueSnackbar(ToastStr.LICENSE_RND_REQUEST_NO_CASH_STR, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else {
					if (data.msg)
						enqueueSnackbar(data.msg, {
							variant: 'error',
						});
					else
						enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
							variant: 'error',
							autoHideDuration: SNACKBAR_TIME,
						});
				}
			});
		handleClose();
	};

	const getLicenseRndConfirm = () => {
		const member = getMember();

		let url = new URL(basic.server + v_member.member + v_member.license_rnd_confirm);
		let params = {
			companyNum: member.companyNum.toString(),
			classCode: member.classCode.toString(),
			licenseNum: props.licenseNum.toString(),
			licensePrice: props.licensePrice.toString(),
			licenseStatus: props.licenseStatus.toString(),
			email: member.id,
			name: member.name,
		};
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code == Values.SUCCESS_CODE) {
					handleOpen();
				} else if (data.code == Values.FAIL_CODE) {
					enqueueSnackbar(Values.FAIL_MESSAGE, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else if (data.code == Values.CLASS_NO_START_CODE) {
					enqueueSnackbar(ToastStr.CLASS_NO_START_STR, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else if (data.code == Values.CLASS_FINISH_CODE) {
					enqueueSnackbar(ToastStr.CLASS_ALREADY_END_STR, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else if (data.code == Values.EXCEPTION_CODE) {
					enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
						variant: 'error',
						autoHideDuration: SNACKBAR_TIME,
					});
				}
			});
	};

	return (
		<Grid container spacing={3}>
			<Grid item xs>
				<Grid container direction="column" style={{ gap: '5px' }}>
					<Grid container alignItems="center" className={classes.iconHeight}>
						<Grid item xs className={classes.iconItem}>
							<img className={classes.icon} src="/images/price.webp" />
						</Grid>
						<Grid>
							<Typography variant="subtitle2">{formatMoney(props.licensePrice)}</Typography>
						</Grid>
					</Grid>
					<Grid container alignItems="center" className={classes.iconHeight}>
						<Grid item xs className={classes.iconItem}>
							<img className={classes.icon} src="/images/time.webp" />
						</Grid>
						<Grid>
							<Typography variant="subtitle2">
								{props.licenseDevelopTime}
								{t('LicenseList.timeSuffix')}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Grid
				item
				xs={8}
				style={{
					display: 'flex',
					justifyContent: 'flex-end',
					alignItems: 'center',
				}}
			>
				<Button variant="contained" className={classes.button} onClick={getLicenseRndConfirm} data-testid={`manu-license-start-btn-${props.licenseNum}`}>
					{t('LicenseList.projectStartButton')}
				</Button>
				<DialogConfirm
					open={dialogState}
					handleClose={handleClose}
					title={t('LicenseList.pageTitle')}
					context={`${t('LicenseList.dialogTitle')}\n${t('LicenseList.dialogContextPrefix')} Lv.${props.licenseLevel} ${licenseName}`}
					yesConfirm={getLicenseRnd}
					noConfirm={handleClose}
				/>
			</Grid>
		</Grid>
	);
};

interface LicenseItemComplete {
	licenseName: string;
	licenseDevelopTime: number;
	licenseStatusStr: string;
	licenseRegDate: string;
}

const LicenseItemComplete: React.FC<any> = (props) => {
	const { t } = useTranslation('student');
	const [progress, setProgress] = useState<number>(
		props.licenseRegDate == undefined || props.now == undefined
			? props.licenseDevelopTime
			: Math.min(props.licenseDevelopTime, Math.max((new Date(props.now.replace(/-/g, '/')).getTime() - new Date(props.licenseRegDate.replace(/-/g, '/')).getTime()) / 1000, 0)),
	);
	const { t: tObject } = useTranslation('object');
	const licenseName = getTranslatedLicenseName(tObject, props.licenseName);
	useEffect(() => {
		if (props.licenseRegDate != undefined) {
			const tick = setTimeout(() => {
				if (progress < props.licenseDevelopTime) {
					setProgress((prevState) => Math.round((prevState + 0.1) * 10) / 10);
				}
				if (progress == props.licenseDevelopTime) {
					props.getLicenseList();
				}
			}, 100);
			return () => clearTimeout(tick);
		}
	}, [progress, props.licenseRegDate]);

	return (
		<Grid container direction="column">
			<Grid container justifyContent="space-between" alignItems="center">
				<Grid xs={8}>
					{progress == props.licenseDevelopTime ? (
						<Typography
							variant="h1"
							style={{
								color: `${COLORS.PUMPKIN}`,
								fontWeight: 'bold',
							}}
						>
							{t('LicenseList.statusCanProduce')}
						</Typography>
					) : (
						<>
							<Typography
								display="inline"
								variant="h1"
								style={{
									color: `${COLORS.BROWNISH_GREY}`,
									fontWeight: 'bold',
								}}
							>
								{licenseName + ' ' + t('LicenseList.statusRnDPrefix')}
							</Typography>
							<Typography
								display="inline"
								variant="h1"
								style={{
									color: `${COLORS.PUMPKIN}`,
									fontWeight: 'bold',
								}}
							>
								{((progress / props.licenseDevelopTime) * 100).toLocaleString(undefined, {
									maximumFractionDigits: 0,
								}) + '% '}
							</Typography>
							<Typography
								display="inline"
								variant="h1"
								style={{
									color: `${COLORS.BROWNISH_GREY}`,
									fontWeight: 'bold',
								}}
							>
								{t('LicenseList.statusDone')}
							</Typography>
						</>
					)}
				</Grid>
				<Grid xs={4} style={{ textAlign: 'end' }}>
					{progress == props.licenseDevelopTime ? (
						<Typography
							variant="h1"
							style={{
								color: `${COLORS.BROWNISH_GREY}`,
								fontFamily: 'NamumSquare_Regular',
							}}
						>
							{t('LicenseList.statusDone')}
						</Typography>
					) : (
						<Typography
							variant="h1"
							style={{
								color: `${COLORS.BROWNISH_GREY}`,
								fontFamily: 'NamumSquare_Regular',
							}}
						>
							{Math.ceil(props.licenseDevelopTime - progress) + t('LicenseList.timeRemainingSuffix')}
						</Typography>
					)}
				</Grid>
			</Grid>

			<Grid>
				<Box alignItems="center">
					<BorderLinearProgress variant="determinate" value={(progress / props.licenseDevelopTime) * 100} />
				</Box>
			</Grid>
		</Grid>
	);
};

const BorderLinearProgress = withStyles({
	root: {
		height: 10,
		width: '100%',
		borderRadius: 20,
	},
	bar: {
		borderRadius: 20,
		backgroundColor: `${COLORS.WATER_BLUE}`,
	},
})(LinearProgress);

const OverlayLock: React.FC<any> = (props) => {
	const classes = useStyles();
	const { firstCant, licenseName } = props;
	const { t } = useTranslation('student');

	return (
		<div className={firstCant ? clsx(classes.overlay, classes.nextOverlay) : classes.overlay}>
			<img src="/images/lock.webp" className={classes.overlayImage}></img>
			<Typography variant="h1" style={{ fontWeight: 'bold', color: `${COLORS.WHITE}` }}>
				{t('LicenseList.overlayFirstProject')}
			</Typography>
		</div>
	);
};

export default LicenseList;
